export default __webpack_public_path__ + "static/media/Wa.20215f08.png";